export default __webpack_public_path__ + "static/media/maingif.0348400f.gif";